import { useEffect } from "react";
import * as Scrivito from "scrivito";
import { useAuth } from "^/Components/Authentication/AuthenticationProvider";
import { getKeycloak } from "^/Components/Authentication/keycloak";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

function RedirectComponent({ page }) {
  const { authenticated } = useAuth();

  const redirectToLogin = () => {
    const redirectUri = window.location.href;
    getKeycloak().login({
      redirectUri,
    });
  };

  useEffect(() => {
    Scrivito.load(() => {
      const link = page.get("link");
      const openInUi = page.get("openInUi");
      const url = link && Scrivito.urlFor(link);

      return { link, openInUi, url };
    }).then(({ link, openInUi, url }) => {
      if (!link) {
        !authenticated && redirectToLogin();
        return;
      }

      if (link.isExternal()) {
        window.open(url);
      } else if (openInUi === "yes") {
        const scrivitoUiUrl = url.replace(/(\/\/[^/]+)/, "$1/scrivito");
        window.top.location.replace(scrivitoUiUrl);
      } else {
        window.location.replace(url);
      }
    });
  }, [authenticated, page]);

  const link = page.get("link");

  if (!link) {
    return (
      <InPlaceEditingPlaceholder center>
        Select a link in the redirect page properties.
      </InPlaceEditingPlaceholder>
    );
  }

  return null;
}

Scrivito.provideComponent("Redirect", Scrivito.connect(RedirectComponent));
